var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("el-card", [
        _c(
          "div",
          {
            staticClass: "clearfix",
            attrs: { slot: "header" },
            slot: "header",
          },
          [
            _c("span", { staticClass: "header-item" }, [_vm._v("Accessories")]),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "ring-card__header-buttons" },
              [
                _c("AddNewAccessory", {
                  attrs: {
                    "customer-profile-id": _vm.customerProfileId,
                    callback: _vm.accessoryRegistered,
                  },
                }),
                _vm._v(" "),
                _c("el-divider", { attrs: { direction: "vertical" } }),
                _vm._v(" "),
                _c("RefreshButton", {
                  nativeOn: {
                    click: function ($event) {
                      return _vm.fetchAccessories()
                    },
                  },
                }),
              ],
              1
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.request.loading,
                expression: "request.loading",
              },
            ],
            staticClass: "card-content",
          },
          [
            _c(
              "el-table",
              { attrs: { data: _vm.accessoriesView, stripe: "" } },
              [
                _c("el-table-column", {
                  attrs: { type: "expand" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (props) {
                        return [
                          _c("accessory-history-tab-pane", {
                            attrs: { "device-id": props.row.device_id },
                          }),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "device_id", label: "Device ID" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "kind", label: "Type" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "state", label: "State" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (props) {
                        return [
                          _c("time-zone-formatter", {
                            attrs: { "current-time": props.row.created_at },
                          }),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                true
                  ? _c("el-table-column", {
                      attrs: { label: "Actions", align: "center" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-tooltip",
                                  {
                                    staticClass: "item",
                                    attrs: {
                                      effect: "dark",
                                      content: "Unregister Accessory",
                                      placement: "top-start",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-popover",
                                      {
                                        attrs: {
                                          title: "Confirmation",
                                          placement: "left",
                                        },
                                        model: {
                                          value: scope.row.deletion.formOpen,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row.deletion,
                                              "formOpen",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "scope.row.deletion.formOpen",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            directives: [
                                              {
                                                name: "loading",
                                                rawName: "v-loading",
                                                value:
                                                  scope.row.deletion.ongoing,
                                                expression:
                                                  "scope.row.deletion.ongoing",
                                              },
                                            ],
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  "text-align": "right",
                                                  margin: "0",
                                                },
                                              },
                                              [
                                                _c("p", [
                                                  _vm._v(
                                                    "Are you sure you want to "
                                                  ),
                                                  _c("strong", [
                                                    _vm._v("delete"),
                                                  ]),
                                                  _vm._v(" this accessory? "),
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "el-button",
                                                  {
                                                    attrs: {
                                                      size: "mini",
                                                      type: "text",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        scope.row.deletion.formOpen = false
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      cancel\n                    "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "el-button",
                                                  {
                                                    attrs: {
                                                      type: "primary",
                                                      size: "mini",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.deleteAccessory(
                                                          scope.$index,
                                                          scope.row
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      confirm\n                    "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "add-new-accessory__alert",
                                              },
                                              [
                                                scope.row.deletion.failed
                                                  ? _c("el-alert", {
                                                      attrs: {
                                                        title:
                                                          "Accessory could be deleted. Contact Admin for help.",
                                                        type: "error",
                                                      },
                                                    })
                                                  : _vm._e(),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            attrs: { slot: "reference" },
                                            slot: "reference",
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-delete",
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        115938808
                      ),
                    })
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }